export const ROUTES = {
  findJobs: '/jobs/find',

  // External (jobs-frontend)
  jobs: '/jobs',
  search: '/jobs/search',

  // External (Crate)
  jobseekerCriteria: '/jobseeker-criteria',
  jobseekerCriteriaSalary: '/jobseeker-criteria/salary',
  profile: '/profile',
  signup: '/signup',
  terms: '/terms',
  privacy: '/privacy',
};

export const XING_PRIVACY_LINK_DE =
  'https://privacy.xing.com/de/datenschutzerklaerung';

export const XING_PRIVACY_LINK_EN =
  'https://privacy.xing.com/en/privacy-policy';
